"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clean = exports.wrappedLines = exports.cleanLines = exports.CodeKind = exports.invokeWrapped = exports.transpileExpressionWrapped = exports.transpileExpression = void 0;
const util_1 = require("../../util");
const names_1 = require("./names");
const helpers_1 = require("./helpers");
const builtins_1 = require("./builtins");
function transpileExpression(e, depth = 0) {
    return invokeWrapped(transpileExpressionWrapped(e, depth));
}
exports.transpileExpression = transpileExpression;
function transpileExpressionWrapped(e, depth = 0) {
    switch (e.kind) {
        case "Literal":
            return transpileLiteral(e);
        case "Identifier":
            return clean(names_1.validJsName(e.name));
        case "Conditional":
            return transpileConditional(e, depth);
        case "Let":
            return transpileLet(e, depth);
        case "Lambda":
            return transpileLambda(e, depth);
        case "Application":
            return transpileApplication(e, depth);
        default:
            util_1.assertUnreachable(e);
    }
}
exports.transpileExpressionWrapped = transpileExpressionWrapped;
function transpileLiteral(literal) {
    const value = literal.value;
    return clean((() => {
        switch (value.kind) {
            case "Boolean":
                return String(value.value);
            case "BigInt":
                return String(value.value);
            case "Number":
                return String(value.value);
            case "Character":
                return JSON.stringify(value.value);
            case "Array":
                return `[${value.contents.map(e => transpileExpression(e)).join(', ')}]`;
            default:
                util_1.assertUnreachable(value);
        }
    })());
}
function transpileConditional(conditional, depth) {
    const { condition, thenBranch, elseBranch } = conditional;
    const conditionCode = transpileExpression(condition, depth + 1);
    const thenCode = transpileExpression(thenBranch, depth + 2);
    const elseCode = transpileExpression(elseBranch, depth + 2);
    return wrappedLines('function () {', `${helpers_1.indent(depth + 1)}if (${conditionCode}) {`, `${helpers_1.indent(depth + 2)}return ${thenCode};`, `${helpers_1.indent(depth + 1)}} else {`, `${helpers_1.indent(depth + 2)}return ${elseCode};`, `${helpers_1.indent(depth + 1)}}`, `${helpers_1.indent(depth)}}`);
}
function transpileLet(letExpression, depth) {
    const { variable, initializer, body } = letExpression;
    const initCode = transpileExpression(initializer, depth + 1);
    const bodyCode = transpileExpression(body, depth + 1);
    return wrappedLines('function () {', `${helpers_1.indent(depth + 1)}const ${names_1.validJsName(variable)} = ${initCode};`, `${helpers_1.indent(depth + 1)}return ${bodyCode};`, `${helpers_1.indent(depth)}}`);
}
function transpileLambda(lambda, depth) {
    const { head, body } = lambda;
    const bodyCode = transpileExpression(body, depth + 1);
    return cleanLines(`function (${names_1.validJsName(head)}) {`, `${helpers_1.indent(depth + 1)}return ${bodyCode};`, `${helpers_1.indent(depth)}}`);
}
function transpileApplication(application, depth) {
    if (shouldTranspileAsUnary(application)) {
        return transpileUnaryExpression(application, depth);
    }
    else if (shouldTranspileAsBinary(application)) {
        return transpileBinaryExpression(application, depth);
    }
    else {
        return transpileRegularCall(application, depth);
    }
}
function transpileUnaryExpression(application, depth) {
    const { argument, callee: operator } = application;
    const argCode = transpileExpression(argument, depth + 1);
    return clean(`${names_1.validJsName(operator.name)}${argCode}`);
}
function transpileBinaryExpression(application, depth) {
    const { argument: arg2, callee: partialCall } = application;
    const { argument: arg1, callee: operator } = partialCall;
    const arg1Code = transpileExpression(arg1, depth + 1);
    const arg2Code = transpileExpression(arg2, depth + 1);
    const expressionCode = `${arg1Code} ${names_1.validJsName(operator.name)} ${arg2Code}`;
    const code = application.parentheses ? `(${expressionCode})` : expressionCode;
    return clean(code);
}
function transpileRegularCall(application, depth) {
    const { callee, argument } = application;
    const calleeCode = transpileExpression(callee, depth);
    const argCode = transpileExpression(argument, depth);
    return clean(`${calleeCode}(${argCode})`);
}
function shouldTranspileAsUnary(application) {
    const callee = application.callee;
    return callee.kind === "Identifier" && builtins_1.isUnaryOperator(callee.name);
}
function shouldTranspileAsBinary(application) {
    const callee = application.callee;
    if (callee.kind !== "Application") {
        return false;
    }
    const firstCallee = callee.callee;
    if (firstCallee.kind !== "Identifier") {
        return false;
    }
    return builtins_1.isBinaryOperator(firstCallee.name);
}
function invokeWrapped(code) {
    return code.kind === CodeKind.Clean ? code.code : `(${code.code}())`;
}
exports.invokeWrapped = invokeWrapped;
var CodeKind;
(function (CodeKind) {
    CodeKind["Clean"] = "Clean";
    CodeKind["Wrapped"] = "Wrapped";
})(CodeKind = exports.CodeKind || (exports.CodeKind = {}));
function cleanLines(...code) {
    return clean(code.join('\n'));
}
exports.cleanLines = cleanLines;
function wrappedLines(...code) {
    return wrapped(code.join('\n'));
}
exports.wrappedLines = wrappedLines;
function clean(code) {
    return {
        kind: CodeKind.Clean,
        code,
    };
}
exports.clean = clean;
function wrapped(code) {
    return {
        kind: CodeKind.Wrapped,
        code,
    };
}
//# sourceMappingURL=expressions.js.map